import React, { useContext, useEffect, useState } from "react";
import { FormGroup, FormLabel } from "react-bootstrap";
import FormSelectField from "../../Components/FormSelectField";
import { Field, Form, Formik, FormikProvider, useFormik } from "formik";
import axios from "axios";
import Account from "../../Services/accountServices";
import { AuthContext } from "../../Auth/Context/AuthContext";
import { message } from "antd";
import Loader from "../../Components/Loader";
import { addAccountSchemaValidation } from "../../config/Validations";
import Branch from "../../Services/branchServices";
function AddBranch(props) {
  const { user } = useContext(AuthContext);
  const [checked, setChecked] = useState(false);
  const [accountTypes, setAccountTypes] = useState([]);
  const [currencies, setCurrencies] = useState([]);
  const [isLoading, setIsloading] = useState(false);

  const AddBranch = async (formValues, { resetForm }) => {
    setIsloading(true);
    formValues.baseCurrencyId = parseInt(formValues.currency);
    formValues.baseCurrencyName = currencies.find(
      (op) => op.id === parseInt(formValues.currency)
    )?.name;
    console.log("DATA", formValues);
    await Branch.createBranch(formValues)
      .then((response) => {
        console.log("Branch CREATED", response);
        if (response.data) {
          setIsloading(false);
          resetForm();
          return message.success("Branch Created Successfully");
        }
      })
      .catch((err) => {
        message.error("Error in Branch Creation", err);
        setIsloading(false);
      });
  };

  const fetchAccountTypes = async () => {
    Account.getAccountTypes().then((types) => {
      setAccountTypes(types.data);
    });
  };
  const fetchCurrencies = async () => {
    Account.getActivatedCurrencies().then((curr) => {
      setCurrencies(curr.data);
    });
  };
  useEffect(() => {
    fetchAccountTypes();
    fetchCurrencies();
  }, []);

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="page-title">
              <h4>Branches</h4>
              <h6>Create new Branch</h6>
            </div>
          </div>

          <div className="card">
            <div className="card-body">
              <Loader loading={isLoading} />
              <div className="row">
                <Formik
                  enableReinitialize
                  initialValues={{
                    name: "",
                    email: "",
                    phone: "",
                    currency: "",
                    description: "",
                  }}
                  onSubmit={AddBranch}
                  // validationSchema={addAccountSchemaValidation}
                >
                  {({
                    errors,
                    touched,
                    setFieldValue,
                    resetForm,
                    setFieldTouched,
                    handleSubmit,
                  }) => (
                    <>
                      <div className="col-lg-3 col-sm-6 col-12">
                        <div className="form-group">
                          <FormGroup>
                            <FormLabel>Branch Name</FormLabel>
                            <Field type="text" name="name" required />
                            {errors.name && touched.name && (
                              <p style={{ color: "red" }}>{errors.name}</p>
                            )}
                          </FormGroup>
                        </div>
                      </div>
                      <div className="col-lg-3 col-sm-6 col-12">
                        <div className="form-group">
                          <FormGroup>
                            <FormLabel>Email</FormLabel>
                            <Field type="text" name="email" required />
                            {errors.email && touched.email && (
                              <p style={{ color: "red" }}>{errors.email}</p>
                            )}
                          </FormGroup>
                        </div>
                      </div>
                      <div className="col-lg-3 col-sm-6 col-12">
                        <div className="form-group">
                          <FormGroup>
                            <FormLabel>Phone</FormLabel>
                            <Field type="text" name="phone" required />
                            {errors.phone && touched.phone && (
                              <p style={{ color: "red" }}>{errors.phone}</p>
                            )}
                          </FormGroup>
                        </div>
                      </div>
                      <div className="col-lg-3 col-sm-6 col-12">
                        <div className="form-group">
                          <FormLabel>Base Currency</FormLabel>
                          <FormSelectField
                            type="select"
                            name="currency"
                            setFieldValue={setFieldValue}
                          >
                            <option value="">Select</option>
                            {currencies &&
                              currencies.map((type) => (
                                <option value={type.id}>{type.name}</option>
                              ))}
                          </FormSelectField>
                          {errors.currency && touched.currency && (
                            <p style={{ color: "red" }}>{errors.currency}</p>
                          )}
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="form-group">
                          <FormGroup>
                            <FormLabel>Description</FormLabel>
                            <Field
                              type="text"
                              className="form-control"
                              name="description"
                            />
                          </FormGroup>
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <a
                          href="#"
                          className="btn btn-submit me-2"
                          onClick={handleSubmit}
                        >
                          Submit
                        </a>
                        <a href="branches" className="btn btn-cancel">
                          Cancel
                        </a>
                      </div>
                    </>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddBranch;
